angular.module('filters').filter('trialPeriodFilter', function() {
  return function(payor) {
    var daysLeft, isOnTrial, now, ref, ref1, trialEnds;
    now = moment();
    trialEnds = moment.parseZone(payor.trial_period_expires_on);
    isOnTrial = trialEnds > now;
    if (isOnTrial) {
      daysLeft = trialEnds.diff(now, 'days');
      return `On trial - ${daysLeft} days`;
    } else {
      if ((ref = payor.braintree_customer.data) != null ? (ref1 = ref.attributes) != null ? ref1.clubworx_subscription_id : void 0 : void 0) {
        return 'Paying Subscriber';
      } else {
        return 'Trial expired';
      }
    }
  };
});
